import Fuse from 'fuse.js';
import { useMemo } from 'react';

export function useSearch<T>(results: T[], keys: string[], query?: string, options?: Fuse.IFuseOptions<T>) {
  const fuse = useMemo(() => {
    return new Fuse<T>(results, {
      keys: keys,
      threshold: options?.threshold === undefined ? 0.3 : options.threshold,
      ...options
    });
  }, [results, keys, options]);

  return useMemo(() => {
    if (!query) return results;
    return fuse.search(query).map(result => result.item);
  }, [fuse, results, query]);
}
